<template>
  <rect
    opacity="0.5"
    x="14"
    y="12"
    width="4"
    height="14"
    rx="1"
    transform="rotate(90 14 12)"
  />
  <rect x="16" width="4" height="16" rx="1" transform="rotate(90 16 0)" />
  <rect
    opacity="0.5"
    x="8"
    y="6"
    width="4"
    height="8"
    rx="1"
    transform="rotate(90 8 6)"
  />
  <mask
    id="path-4-outside-1_10752_8766"
    maskUnits="userSpaceOnUse"
    x="4"
    y="5"
    width="12"
    height="12"
    fill="black"
  >
    <rect fill="white" x="4" y="5" width="12" height="12" />
    <path
      d="M15 11C15 13.7614 12.7614 16 10 16C7.23858 16 5 13.7614 5 11C5 8.23858 7.23858 6 10 6C12.7614 6 15 8.23858 15 11Z"
    />
  </mask>
  <path
    d="M15 11C15 13.7614 12.7614 16 10 16C7.23858 16 5 13.7614 5 11C5 8.23858 7.23858 6 10 6C12.7614 6 15 8.23858 15 11Z"
    fill="white"
  />
  <path
    d="M14 11C14 13.2091 12.2091 15 10 15V17C13.3137 17 16 14.3137 16 11H14ZM10 15C7.79086 15 6 13.2091 6 11H4C4 14.3137 6.68629 17 10 17V15ZM6 11C6 8.79086 7.79086 7 10 7V5C6.68629 5 4 7.68629 4 11H6ZM10 7C12.2091 7 14 8.79086 14 11H16C16 7.68629 13.3137 5 10 5V7Z"
    fill="white"
    mask="url(#path-4-outside-1_10752_8766)"
  />
  <path
    d="M15.7678 12.2764L15.4225 12.0549C15.0549 11.8122 14.8321 11.4219 14.8321 11C14.8321 10.5781 15.0549 10.1772 15.4225 9.94515L15.7678 9.72363C16.0018 9.57595 16.0686 9.28059 15.9238 9.05907L15.2443 7.94093C15.1106 7.70886 14.8098 7.62447 14.5536 7.74051L14.1637 7.91983C13.7627 8.09916 13.3059 8.07806 12.916 7.87764C12.916 7.87764 12.9049 7.87764 12.9049 7.86709C12.5262 7.65612 12.2699 7.28692 12.2365 6.86498L12.2031 6.46414C12.1808 6.20042 11.9469 6 11.6795 6H10.3205C10.042 6 9.80804 6.20042 9.7969 6.46414L9.76348 6.86498C9.73006 7.28692 9.48499 7.65612 9.09509 7.86709C9.09509 7.86709 9.08395 7.86709 9.08395 7.87764C8.7052 8.08861 8.23733 8.09916 7.83629 7.91983L7.4464 7.72996C7.20132 7.61392 6.90055 7.70886 6.75573 7.93038L6.0762 9.04852C5.94252 9.28059 6.00936 9.5654 6.23216 9.71308L6.57749 9.9346C6.94511 10.1772 7.1679 10.5675 7.1679 10.9895C7.1679 11.4114 6.94511 11.8122 6.57749 12.0443L6.23216 12.2658C5.99822 12.4135 5.93138 12.7089 6.0762 12.9304L6.75573 14.0591C6.88941 14.2911 7.19018 14.3755 7.4464 14.2595L7.83629 14.0802C8.23733 13.9008 8.69406 13.9219 9.08395 14.1224C9.08395 14.1224 9.09509 14.1224 9.09509 14.1329C9.47385 14.3439 9.73006 14.7131 9.76348 15.135L9.7969 15.5359C9.81918 15.7996 10.0531 16 10.3205 16H11.6795C11.958 16 12.192 15.7996 12.2031 15.5359L12.2365 15.135C12.2699 14.7131 12.515 14.3439 12.9049 14.1329C12.9049 14.1329 12.916 14.1329 12.916 14.1224C13.2948 13.9114 13.7627 13.9008 14.1637 14.0802L14.5536 14.2595C14.7987 14.3755 15.0995 14.2806 15.2443 14.0591L15.9238 12.9409C16.0575 12.7194 15.9906 12.4346 15.7678 12.2764ZM11 13.1308C9.75234 13.1308 8.74976 12.1709 8.74976 11C8.74976 9.82911 9.75234 8.8692 11 8.8692C12.2477 8.8692 13.2502 9.82911 13.2502 11C13.2502 12.1709 12.2477 13.1308 11 13.1308Z"
  />
</template>
